import React, { useState } from "react";

// third-party
import { Link } from "react-router-dom";
import { PopupButton } from "react-calendly";

// project-imports
import {
  GoogleAnalyticsEnum,
  triggerFunction,
} from "../../utils/google-analytics";
import FooterOneStencil from "./FooterOneStencil";
import TestimonialModal from "../../components/testimonial/TestimonialModal";
import { showToast } from "../../components/sweet-alert/Sweetalert";
import { TopicSuggestionForm } from "../../components/form/TopicSuggestionForm";
import ScrollTopButton from "./ScrollTopButton";
import CalendlyPopupButton from "../../components/calendly/CalendlyPopupButton";

// Reading environment variable start
const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL;
const LINKEDIN_URL = process.env.REACT_APP_LINKEDIN_URL;
const OFFICIAL_WEBSITE_URL = process.env.REACT_APP_OFFICIAL_WEBSITE_URL;
const OFFICIAL_LONGSWITCH_WEBSITE_URL = process.env.REACT_APP_OFFICIAL_LONGSWITCH_WEBSITE_URL;
const OFFICIAL_PHONE_NUMBER = process.env.REACT_APP_OFFICIAL_PHONE_NUMBER;
const OFFICIAL_EMAIL_ADDRESS = process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS;
// Reading environment variable end

// Constant variable for get full-year
const year = new Date().getFullYear();

const FooterOne = ({ stencilLoading }) => {

  // State variable initialization
  const [testimonialModal, setTestimonialModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  if (stencilLoading) {
    return <FooterOneStencil />;
  }

  // Constant function
  const toggleTestimonialModal = () => {
    try {
      setTestimonialModal(!testimonialModal);
    } catch (error) {
      console.error("43 : FooterOne : Error occurred in toggleTestimonialModal:", error && JSON.stringify(error));
      showToast(
        "error",
        "Something went wrong while toggling the testimonial modal. Please try again.",
        true,
        "bottom-right",
        false,
        true,
        5000
      );
    }
  };

  const onClickSuggestionForm = () => {
    setShowModal(true);
  }

  const onCloseSuggestionForm = () => {
    setShowModal(false);
  }

  return (
    <>
      {testimonialModal && (
        <>
          <TestimonialModal
            toggleModal={toggleTestimonialModal}
            extraClass="ml--10 mr--10"
          />
        </>
      )}

      <footer className="eduvibe-footer-two edu-footer-with-cta">
        <div className="edu-cta-area cta-with-overlay" style={{ display: "none" }}>
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-6">
                <div className="call-action-style-1 bg-color-primary radius-small">
                  <div className="inner">
                    <div className="row align-items-center">
                      <div className="col-12 col-sm-6">
                        <div className="content">
                          <div className="section-title text-white">
                            <span className="pre-title">Suggest a Topic to us</span>
                            <h5 className="title">
                              Have a topic you'd like us to cover?
                            </h5>
                          </div>
                          <div className="read-more-btn mt--30">
                            {/* <a className="edu-btn btn-medium btn-white" href={YOUTUBE_CHANNEL_URL} onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.COMMON_FOOTER_APPLY_NOW)} target="_blank" rel="noreferrer">Apply Now<i
                                                            className="icon-arrow-right-line-right"></i></a> */}
                            <button
                              className="edu-btn btn-medium btn-white"
                              onClick={() => onClickSuggestionForm()}
                            >
                              Suggest A Topic
                              <i className="icon-arrow-right-line-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 d-none d-sm-block">
                        <div className="thumbnail">
                          <img
                            className="main-img"
                            src="/images/footer/cta-image-01.png"
                            alt="Cta images"
                          />
                          <div className="shape-image">
                            <img
                              src="/images/footer/shape-05.png"
                              alt="Shape Images"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="call-action-style-1 box-layout bg-color-secondary radius-small">
                  <div className="inner">
                    <div className="content">
                      <div className="section-title text-white">
                        <span className="pre-title">
                          Schedule Your 1:1 Consultation
                        </span>
                        <h5 className="title">
                          Get personalised guidance <br />
                          tailored to your goals!
                        </h5>
                      </div>
                      <div className="newsletter-form-box">
                        <div className="newsletter-style-2">
                          <form action="#">
                            <div className="mt--30">
                              <Link
                                // className="edu-btn  btn-medium btn-dark mb-0"
                                to="#"
                                onClick={() =>
                                  triggerFunction(
                                    GoogleAnalyticsEnum.BUTTON,
                                    GoogleAnalyticsEnum.COMMON_FOOTER_SUBSCRIBE_NOW
                                  )
                                }
                                target="_blank"
                              >
                                <CalendlyPopupButton btnText="Book 1:1 Consultation" />
                                {/* <i className="icon-arrow-right-line-right"></i> */}
                              </Link>

                            </div>
                          </form>

                        </div>
                      </div>
                      <div className="shape-image-2">
                        <img
                          src="/images/footer/shape-06.png"
                          alt="Shape Images"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="eduvibe-footer-one edu-footer footer-style-default">
          <div className="footer-top">
            <div className="container eduvibe-animated-shape">
              <div className="row g-5">
                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                  <div className="row">
                    <div className="col-12 text-center">
                      <Link
                        to={process.env.PUBLIC_URL + "/"}
                        onClick={() =>
                          triggerFunction(
                            GoogleAnalyticsEnum.BUTTON,
                            GoogleAnalyticsEnum.COMMON_FOOTER_LOGO
                          )
                        }
                      >
                        <img
                          className="w-75"
                          src="/images/logo/lsa-long-logo-white.png"
                          alt="Footer Logo"
                        />
                      </Link>
                    </div>
                    <div className="col-12">
                      <ul className="social-share mt--20">
                        <li>
                          <a
                            href={OFFICIAL_WEBSITE_URL}
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_OFFICIAL_WEBSITE
                              )
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="icon-Browser"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href={LINKEDIN_URL}
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_OFFICIAL_LINKEDIN
                              )
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="icon-linkedin"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href={YOUTUBE_CHANNEL_URL}
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_OFFICIAL_YOUTUBE
                              )
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="icon-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="edu-footer-widget explore-widget">
                    <h5 className="widget-title">Explore</h5>
                    <div className="inner">
                      <ul className="footer-link link-hover">
                        {/* <li>
                          <Link
                            to="/about-us"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_ABOUT_US
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_ABOUT_US
                                )
                              }
                            ></i>
                            About Us{" "}
                          </Link>
                        </li> */}
                        <li>
                          <Link
                            to="/salesforce-tutorials"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_SALESFORCE_TUTORIALS
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_SALESFORCE_TUTORIALS
                                )
                              }
                            ></i>
                            Salesforce Tutorials{" "}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/salesforce-quick-insights/all"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_SALESFORCE_QUICK_INSIGHTS
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_SALESFORCE_QUICK_INSIGHTS
                                )
                              }
                            ></i>
                            Quick Insights{" "}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/#popular-interview-topics-to-learn"
                          // onClick={() =>
                          //   triggerFunction(
                          //     GoogleAnalyticsEnum.LINK,
                          //     GoogleAnalyticsEnum.COMMON_FOOTER_SALESFORCE_TUTORIALS
                          //   )
                          // }
                          >
                            <i
                              className="icon-Double-arrow"
                            // onClick={() =>
                            //   triggerFunction(
                            //     GoogleAnalyticsEnum.LINK,
                            //     GoogleAnalyticsEnum.COMMON_FOOTER_SALESFORCE_TUTORIALS
                            //   )
                            // }
                            ></i>
                            Interview Q&A{" "}
                          </Link>
                        </li>
                        {/* BLOGS WE WILL RELEASE IN NEXT VERSION  Start*/}
                        {/* <li>
                          <Link
                            to="/blogs"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_BLOG_NEWS
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_BLOG_NEWS
                                )
                              }
                            ></i>
                            Blog & News
                          </Link>
                        </li> */}
                        {/* BLOGS WE WILL RELEASE IN NEXT VERSION End*/}
                        <li>
                          <Link
                            to="/faqs"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_FAQ
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_FAQ
                                )
                              }
                            ></i>
                            FAQ
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/testimonial"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_TESTIMONIAL
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_TESTIMONIAL
                                )
                              }
                            ></i>
                            Testimonial
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/privacy-policy"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOTTER_PRIVACY_POLICY
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOTTER_PRIVACY_POLICY
                                )
                              }
                            ></i>
                            Privacy Policy
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="edu-footer-widget quick-link-widget">
                    <h5 className="widget-title">Useful Links</h5>
                    <div className="inner">
                      <ul className="footer-link link-hover">
                        <li>
                          <Link
                            to="/about-us"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_ABOUT_US
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_ABOUT_US
                                )
                              }
                            ></i>
                            About Us{" "}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/contact-us"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_CONTACT_US
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_CONTACT_US
                                )
                              }
                            ></i>
                            Contact Us
                          </Link>
                        </li>
                        {/* <li>
                          <Link
                            to="/salesforce-courses"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_POPULAR_COURSES
                              )
                            }
                          >
                            <i className="icon-Double-arrow"></i>Popular Courses
                          </Link>
                        </li> */}
                        <li>
                          <Link
                            to="/our-offerings/salesforceAdmin"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.SF_ALL_PRICING
                              )
                            }
                          >
                            <i className="icon-Double-arrow"></i>Pricing
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/our-resources/paid"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.SF_ALL_RESOURCES
                              )
                            }
                          >
                            <i className="icon-Double-arrow"></i>E-Books
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/get-free-consultation"
                            onClick={() =>
                              triggerFunction(
                                GoogleAnalyticsEnum.LINK,
                                GoogleAnalyticsEnum.COMMON_FOOTER_ABOUT_US
                              )
                            }
                          >
                            <i
                              className="icon-Double-arrow"
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_ABOUT_US
                                )
                              }
                            ></i>
                            Book 1:1 Consultation{" "}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="edu-footer-widget">
                    <h5 className="widget-title">Contact Info</h5>
                    <div className="inner">
                      <div className="widget-information">
                        <ul className="information-list">
                          <li className="fs-15">
                            <i className="icon-map-pin-line"></i>
                            <a href="http://maps.google.com/?q=J9 High Street, Gujarat 395007" target="blank" className="text-break">125-126, J9 High
                              Street, Vesu, Surat, Gujarat, India-395007.
                            </a>
                          </li>
                          <li className="fs-15">
                            <i className="icon-phone-fill"></i>
                            <a
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_OFFICIAL_PHONE_NUMBER
                                )
                              }
                              className="text-break"
                              href={`tel: ${OFFICIAL_PHONE_NUMBER}`}
                            >
                              {OFFICIAL_PHONE_NUMBER}
                            </a>
                          </li>
                          <li className="fs-15">
                            <i className="icon-Browser"></i>{" "}
                            <a
                              href={OFFICIAL_WEBSITE_URL}
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_OFFICIAL_WEBSITE
                                )
                              }
                              className="text-break"
                              target="_blank"
                              rel="noreferrer"
                            >
                              www.longswitchacademy.com
                            </a>
                          </li>
                          <li className="fs-15">
                            <i className="icon-mail-line-2"></i>
                            <a
                              target="_blank"
                              href={`mailto: ${OFFICIAL_EMAIL_ADDRESS}`}
                              onClick={() =>
                                triggerFunction(
                                  GoogleAnalyticsEnum.LINK,
                                  GoogleAnalyticsEnum.COMMON_FOOTER_OFFICIAL_EMAIL_ADDRESS
                                )
                              }
                              className="text-break"
                              rel="noreferrer"
                            >
                              {OFFICIAL_EMAIL_ADDRESS}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Modified by Longswitch Team added xxl for that nest hub max scroll issue  */}
              {/* <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                <div className="shape-image shape-image-1">
                  <img src="/images/shapes/shape-21-01.png" alt="Shape Thumb" />
                </div>
                <div className="shape-image shape-image-2">
                  <img src="/images/shapes/shape-35.png" alt="Shape Thumb" />
                </div>
              </div> */}
            </div>
          </div>
          <div className="copyright-area copyright-default">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="inner text-center">
                    <p className="fs-15">
                      Copyright {year} Powered By{" "}
                      <a
                        href={OFFICIAL_LONGSWITCH_WEBSITE_URL}
                        onClick={() =>
                          triggerFunction(
                            GoogleAnalyticsEnum.BUTTON,
                            GoogleAnalyticsEnum.COPPY_RIGHT_OFFICAL_WEBSITE
                          )
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        Longswitch Software Solutions Pvt Ltd
                      </a>
                      . All Rights Reserved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <TopicSuggestionForm show={showModal} onCloseModal={onCloseSuggestionForm} title={"Suggest a topic to us"} />
      <ScrollTopButton />
    </>
  );
};

export default FooterOne;
